module.exports = __webpack_public_path__ + "static/media/open-in-new-w64.73b4cb51.svg";